import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const GeneralErrorPage = () => {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", py: 8 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "6rem",
            fontWeight: "bold",
            color: "warning.main",
            mb: 2,
          }}
        >
          !
        </Typography>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Something went wrong
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          An unexpected error occurred. Please try again later.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          size="large"
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </Button>
      </Box>
    </Container>
  );
};

export default GeneralErrorPage;
